import { render, staticRenderFns } from "./Tab4.vue?vue&type=template&id=b372144e&scoped=true"
import script from "./Tab4.vue?vue&type=script&lang=js"
export * from "./Tab4.vue?vue&type=script&lang=js"
import style0 from "./Tab4.vue?vue&type=style&index=0&id=b372144e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b372144e",
  null
  
)

export default component.exports